import Vue from 'vue';

export default {
    // questions
    loadAllQuestions(state) {
        Vue.set(state.questions, 'data', []);
        Vue.set(state.questions, 'dataLoading', true);
        Vue.set(state.questions, 'hasLoaded', false);
    },
    loadAllQuestionsSuccess(state, payload) {
        Vue.set(state.questions, 'data', payload);
        Vue.set(state.questions, 'dataLoading', false);
        Vue.set(state.questions, 'hasLoaded', true);
    },
    loadAllQuestionsError(state) {
        Vue.set(state.questions, 'dataLoading', false);
        Vue.set(state.questions, 'hasError', true);
        Vue.set(state.questions, 'hasLoaded', true);
    },
    selectQuestion(state, payload) {
        Vue.set(state.questions, 'selectedQuestion', payload);
    },

    // categories
    loadAllQuestionCategories(state) {
        Vue.set(state.questions, 'categories', []);
        Vue.set(state.questions, 'categoriesLoading', true);
    },
    loadAllQuestionCategoriesSuccess(state, payload) {
        Vue.set(state.questions, 'categories', payload);
        Vue.set(state.questions, 'categoriesLoading', false);
    },
    loadAllQuestionCategoriesError(state) {
        Vue.set(state.questions, 'categoriesLoading', false);
        Vue.set(state.questions, 'hasError', true);
    },
    updateQuestionCategoryFilter(state, payload) {
        let categories = [ ...state.questions.categoryFilter ],
            index = categories.indexOf(payload);
        if (index > -1) {
            categories.splice(index, 1);
        } else {
            categories.push(payload);
        }
        Vue.set(state.questions, 'categoryFilter', categories);
    },

    // search
    searchQuestions(state) {
        Vue.set(state.questions, 'searchLoading', true);
        Vue.set(state.questions, 'hasError', false);
    },
    searchQuestionsSuccess(state, payload) {
        Vue.set(state.questions, 'searchQuery', payload.query);
        Vue.set(state.questions, 'searchResults', payload.data.map(id => parseInt(id)));
        Vue.set(state.questions, 'searchLoading', false);
    },
    searchQuestionsError(state) {
        Vue.set(state.questions, 'searchLoading', false);
        Vue.set(state.questions, 'hasError', true);
    },
    searchReset(state) {
        Vue.set(state.questions, 'searchQuery', null);
        Vue.set(state.questions, 'searchLoading', false);
        Vue.set(state.questions, 'hasError', false);
    },

};
